import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, postData, putData } from "src/utils/axios/serverHelper";

import { SYS1010_R01Dto, SYS1010_R01UpdateDto } from "./Dto_SYS1010_R01";
import { SYS1010_R01Filter } from "./Store_SYS1010_R01";

const baseUrl = `${config.apiUrl}/SYS1010_R01`;

export const getSYS1010_R01List = async (option: string, params: Partial<SYS1010_R01Filter>, listLength: number = 0) => {
	
  const url = `${baseUrl}/${option}`;

  const requestParams = {
		majorCd: params?.codeInput,
	}

  return await getData<ResponseDto<SYS1010_R01Dto[]>>(url, { params: {
		...requestParams,
		listLength
	} });
}

export const getSYS1010_R01AllCount = async (params: Partial<SYS1010_R01Filter>) => {
    const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, {
        params: {
            ...params
        }
    });
}

// export const getPartSYS1010_R01List = async (majorCode: string) => {
// 	const url = `${baseUrl}/part`;
// 	return await getData<ResponseDto<SYS1010_R01Dto[]>>(url, { params: { majorCode } });
// }

export const getSYS1010_R01MinorCodeList = async (majorCode: string) => {
	
	return await getData<ResponseDto<SYS1010_R01Dto[]>>(baseUrl, {
		params: { majorCode }
	});
}

export const createSYS1010_R01 = async (data: SYS1010_R01Dto) => {
	
  return await postData<SYS1010_R01Dto, ResponseDto<SYS1010_R01Dto>>(baseUrl, data);
}

export const saveSYS1010_R01 = async (majorCode: SYS1010_R01Dto, minorCodeList: SYS1010_R01Dto[]) => {

  const data: SYS1010_R01UpdateDto= {
    majorCodeDto: majorCode,
    minorCodeDtoList: minorCodeList
  }

  return await putData<SYS1010_R01UpdateDto, ResponseDto<SYS1010_R01UpdateDto>>(baseUrl, data);
}

export const deleteSYS1010_R01 = async (majorCode: string) => {
  const url = `${baseUrl}/${majorCode}`;

  return await deleteData<ResponseDto<any>>(url);
}

export const downloadExcel_SYS1010_R01 = async (majorCode?: string) => {
  const url = `${baseUrl}/common/excel`;
  
  const params = majorCode ? { majorCode } : {};
  
  // 백엔드에서 byte[] 배열 또는 Base64 문자열로 반환될 수 있음
  return await getData<ResponseDto<string | number[]>>(url, { params });
}